"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOpenIDMetadataFetcher = void 0;
var isObject_1 = require("./isObject");
var SGWTConnectError_1 = require("./SGWTConnectError");
var SGWTConnectErrorList_1 = require("./SGWTConnectErrorList");
/**
 * Generates a function that upon invocation asynchronously
 * fetches OpenID Metadata from the OpenID Provider.
 * @param authorization_endpoint OpenID Provider's endpoint URL.
 */
function createOpenIDMetadataFetcher(authorization_endpoint) {
    return function fetchOpenIDMetadata(callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', authorization_endpoint + "/oauth2/.well-known/openid-configuration");
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.addEventListener('load', function onOpenIDMetadataLoad() {
            if (xhr.status === 200) {
                var openIDMetadata = void 0;
                try {
                    openIDMetadata = JSON.parse(xhr.responseText);
                }
                catch (_a) {
                    callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList_1.ERR_FAILED_TO_PARSE_OPENID_METADATA));
                    return;
                }
                if (isValidOpenIDMetadata(openIDMetadata)) {
                    callback(openIDMetadata);
                }
                else {
                    callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList_1.ERR_FAILED_TO_VALIDATE_OPENID_METADATA));
                }
            }
            else {
                callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList_1.ERR_FAILED_TO_FETCH_OPENID_METADATA));
            }
        });
        xhr.send();
    };
}
exports.createOpenIDMetadataFetcher = createOpenIDMetadataFetcher;
/**
 * Determines whether the given OpenID Configuration is valid.
 * @param openIDMetadata JSON-parsed value obtained from the Discovery API.
 */
function isValidOpenIDMetadata(openIDMetadata) {
    return isObject_1.isObject(openIDMetadata) &&
        typeof openIDMetadata.check_session_iframe === 'string' &&
        typeof openIDMetadata.end_session_endpoint === 'string';
}
//# sourceMappingURL=SGWTConnectOpenIDMetadata.js.map